import { computed, ref, toValue, watchEffect } from 'vue';
import { CourseStore } from '@student/modules/store';
import { clone } from '@common/utils/Helpers/Helpers';
import { sortArray } from '@common/utils/Array/Array';
import { getCurrencyByCode } from '@common/utils/Currencies/Currencies';
import Dom from '@common/utils/Dom';
import { parseTextWithUrl as utilsParseTextWithUrl, } from '@common/utils/String/String';
export var useLandingBlock = function (propsLandingBlock) {
    var landingBlock = ref(propsLandingBlock);
    watchEffect(function () {
        landingBlock.value = toValue(propsLandingBlock);
    });
    var courseLanding = computed(function () { return CourseStore.landing; });
    var cards = computed(function () {
        if (!landingBlock.value.cards) {
            return [];
        }
        return landingBlock.value.cards.sort(function (a, b) {
            return a.order - b.order;
        });
    });
    var plansPayment = computed(function () {
        var _a;
        return (_a = courseLanding.value) === null || _a === void 0 ? void 0 : _a.plansPayment;
    });
    var plans = computed(function () {
        var _a;
        if (!courseLanding.value) {
            return [];
        }
        return clone((_a = courseLanding.value.blocks.find(function (l) { return l.type === 'block_order_plan'; })) === null || _a === void 0 ? void 0 : _a.cards);
    });
    var minimalPlansPrice = computed(function () {
        var _a;
        if (!plans.value) {
            return null;
        }
        var plansLocal = sortArray(plans.value, 'price', 'asc');
        return (_a = plansLocal[0]) === null || _a === void 0 ? void 0 : _a.price;
    });
    var minimalPlansPriceOld = computed(function () {
        var _a;
        if (!plans.value) {
            return null;
        }
        var plansLocal = sortArray(plans.value, 'price', 'asc');
        return (_a = plansLocal[0]) === null || _a === void 0 ? void 0 : _a.priceOld;
    });
    var hasDiscount = computed(function () {
        return (!courseLanding.value.plansPayment && courseLanding.value.priceOld > 0) || (courseLanding.value.plansPayment && minimalPlansPriceOld.value);
    });
    var landingCurrency = computed(function () {
        return getCurrencyByCode(courseLanding.value.currency);
    });
    var isLinkIcon = function (link) {
        return !link || (link).startsWith('icons-public');
    };
    var emailKeyFilter = function (e) {
        if (e.code === 'Space') {
            e.preventDefault();
            return false;
        }
    };
    var trimEmailValue = function (form, emailKey) {
        if (form[emailKey].match(/\s/) !== null) {
            form[emailKey] = form[emailKey].replace(/\s+/, '');
        }
    };
    var showOrderForm = function (plan) {
        if (plan === void 0) { plan = null; }
        CourseStore.landingOrderFormVisibility = true;
        CourseStore.landingOrderFormPlan = plan;
    };
    var goOrderPlans = function () {
        var plansBlockIndex = courseLanding.value.blocks.findIndex(function (b) { return b.type === 'block_order_plan'; });
        var plansBlock = document.querySelector("main > section.section:nth-child(".concat(plansBlockIndex + 1, ")"));
        if (!plansBlock)
            return;
        var containerTopOffset = plansBlock.offsetTop;
        window.scroll({
            top: containerTopOffset,
            left: 0,
            behavior: 'smooth',
        });
    };
    var orderAction = function () {
        if (courseLanding.value.plansPayment) {
            goOrderPlans();
        }
        else {
            showOrderForm();
        }
    };
    var parseTextWithUrl = function (html) {
        // Оставляем только теги br
        var clearHtml = Dom.stripTagsInString(html, ['br'], true);
        // Оборачиваем все ссылки в <a>
        return utilsParseTextWithUrl({
            text: clearHtml, classNames: 'text-primary hover:underline', escapeText: false
        });
    };
    return {
        landingBlock: landingBlock,
        courseLanding: courseLanding,
        cards: cards,
        plansPayment: plansPayment,
        plans: plans,
        minimalPlansPrice: minimalPlansPrice,
        minimalPlansPriceOld: minimalPlansPriceOld,
        hasDiscount: hasDiscount,
        landingCurrency: landingCurrency,
        isLinkIcon: isLinkIcon,
        emailKeyFilter: emailKeyFilter,
        trimEmailValue: trimEmailValue,
        showOrderForm: showOrderForm,
        goOrderPlans: goOrderPlans,
        orderAction: orderAction,
        parseTextWithUrl: parseTextWithUrl,
    };
};
